import "./PropertyFacilitiesManagement.module.css";
import Header from "@/reusable_sections/Header";
import Facilities from "./sections/Facilities";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function PropertyFacilitiesManagementPage() {
  return <div>
      <Header />
      <Facilities />
      <Partnership />
      <Footer />
    </div>;
}